<template>
    <div id="app">
        <router-view></router-view>
        <vue-progress-bar></vue-progress-bar>
    </div>
</template>
<script>
    export default {
        components:{

        },
        name: "app",
        mounted() {
            // window.particlesJS.load

        }
    }
</script>

<style lang="less">
    html,body,#app{
        width: 100%;
        margin: 0;
        font-size: 14px;
        height: 100%;
        background-color: #f1f1f1;
    }
</style>
